webpackJsonp([143588238614448],{

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _OptimizationDetailsSectionModule = __webpack_require__(659);
	
	var _OptimizationDetailsSectionModule2 = _interopRequireDefault(_OptimizationDetailsSectionModule);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(29);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _RetinaImage = __webpack_require__(12);
	
	var _RetinaImage2 = _interopRequireDefault(_RetinaImage);
	
	var _reactstrap = __webpack_require__(3);
	
	var _Animations = __webpack_require__(5);
	
	var _imgLaptopZoneAndWeight = __webpack_require__(49);
	
	var _imgLaptopZoneAndWeight2 = _interopRequireDefault(_imgLaptopZoneAndWeight);
	
	var _imgLaptopZoneAndWeight2x = __webpack_require__(50);
	
	var _imgLaptopZoneAndWeight2x2 = _interopRequireDefault(_imgLaptopZoneAndWeight2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'src-components----OptimizationDetailsSection-module---optimization-details-section---3Zgq9' },
	        _react2.default.createElement(
	            _reactstrap.Container,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'src-components----OptimizationDetailsSection-module---text-container---3DY1f' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h2' },
	                    'Save up to 40% on shipping'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h2 text-blue' },
	                    'Let our experts get to work.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'src-components----OptimizationDetailsSection-module---features-table---3n9Ls' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----OptimizationDetailsSection-module---feature-row---3d3cm' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'src-components----OptimizationDetailsSection-module---heading---1l_0k' },
	                            'Rate benchmarking'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'See how your rates stack up against the market. We\u2019ll run a preliminary savings estimate for you at no cost and with no commitment.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----OptimizationDetailsSection-module---feature-row---3d3cm' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'src-components----OptimizationDetailsSection-module---heading---1l_0k' },
	                            'Service configuration'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Discover the perfect shipping setup. Based on your requirements, we\u2019ll craft a plan \u2014 carriers, services, and routing logic \u2014 that will delight your customers and terrify your competitors.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----OptimizationDetailsSection-module---feature-row---3d3cm' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'src-components----OptimizationDetailsSection-module---heading---1l_0k' },
	                            'Assisted negotiations'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Let us do the heavy lifting. Our team of experts will guide you through the complex negotiation process and quantify your savings before you sign any new carrier contracts.'
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Animations.ScrollOverPack,
	            { className: 'src-components----OptimizationDetailsSection-module---splash-image-container---_FDIi' },
	            _react2.default.createElement(_Animations.TweenOne, _extends({ key: '0',
	                component: _RetinaImage2.default,
	                srcSet: [_imgLaptopZoneAndWeight2.default, _imgLaptopZoneAndWeight2x2.default],
	                className: 'src-components----OptimizationDetailsSection-module---splash-image---Hhp7m'
	            }, _Animations.FadeLeft))
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 659:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"optimization-details-section":"src-components----OptimizationDetailsSection-module---optimization-details-section---3Zgq9","text-container":"src-components----OptimizationDetailsSection-module---text-container---3DY1f","message":"src-components----OptimizationDetailsSection-module---message---rmrNv","features-table":"src-components----OptimizationDetailsSection-module---features-table---3n9Ls","feature-row":"src-components----OptimizationDetailsSection-module---feature-row---3d3cm","heading":"src-components----OptimizationDetailsSection-module---heading---1l_0k","splash-image-container":"src-components----OptimizationDetailsSection-module---splash-image-container---_FDIi","splash-image":"src-components----OptimizationDetailsSection-module---splash-image---Hhp7m"};

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-iphone-unit-cost-zones.63673372.png";

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-iphone-unit-cost-zones@2x.cbc9a6f2.png";

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-iphone-unit-cost-zones@3x.eed281d1.png";

/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _dashboardModule = __webpack_require__(55);
	
	var _dashboardModule2 = _interopRequireDefault(_dashboardModule);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(3);
	
	var _Animations = __webpack_require__(5);
	
	var _ButtonLink = __webpack_require__(14);
	
	var _ButtonLink2 = _interopRequireDefault(_ButtonLink);
	
	var _RetinaImage = __webpack_require__(12);
	
	var _RetinaImage2 = _interopRequireDefault(_RetinaImage);
	
	var _FeaturesLinksSection = __webpack_require__(51);
	
	var _FeaturesLinksSection2 = _interopRequireDefault(_FeaturesLinksSection);
	
	var _OptimizationDetailsSection = __webpack_require__(369);
	
	var _OptimizationDetailsSection2 = _interopRequireDefault(_OptimizationDetailsSection);
	
	var _UptimeSplash = __webpack_require__(92);
	
	var _UptimeSplash2 = _interopRequireDefault(_UptimeSplash);
	
	var _imgIphoneUnitCostZones = __webpack_require__(247);
	
	var _imgIphoneUnitCostZones2 = _interopRequireDefault(_imgIphoneUnitCostZones);
	
	var _imgIphoneUnitCostZones2x = __webpack_require__(248);
	
	var _imgIphoneUnitCostZones2x2 = _interopRequireDefault(_imgIphoneUnitCostZones2x);
	
	var _imgIphoneUnitCostZones3x = __webpack_require__(249);
	
	var _imgIphoneUnitCostZones3x2 = _interopRequireDefault(_imgIphoneUnitCostZones3x);
	
	var _iconOptimization = __webpack_require__(235);
	
	var _iconOptimization2 = _interopRequireDefault(_iconOptimization);
	
	var _iconOptimization2x = __webpack_require__(236);
	
	var _iconOptimization2x2 = _interopRequireDefault(_iconOptimization2x);
	
	var _iconOptimization3x = __webpack_require__(237);
	
	var _iconOptimization3x2 = _interopRequireDefault(_iconOptimization3x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hero = function Hero(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'src-pages-features----dashboard-module---hero---RX6K-' },
	        _react2.default.createElement(
	            _reactstrap.Container,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'src-pages-features----dashboard-module---text-container---3CHyn' },
	                _react2.default.createElement(_RetinaImage2.default, { srcSet: [_iconOptimization2.default, _iconOptimization2x2.default, _iconOptimization3x2.default] }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h1 mt-2' },
	                    'Optimization'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h2 text-blue' },
	                    'Tune your shipping engine.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'src-pages-features----dashboard-module---message---TYnoZ' },
	                    'Opaque pricing schemes, complex optimization problems, and a shifting landscape of carriers and services \u2014 shipping is a hard game to win. Optimization levels the playing field.'
	                ),
	                _react2.default.createElement(
	                    _ButtonLink2.default,
	                    { className: 'src-pages-features----dashboard-module---button---3mu4_', to: '/contact' },
	                    'Try free for 7 days'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Animations.ScrollOverPack,
	            { className: 'src-pages-features----dashboard-module---splash-image-container---1iBIF' },
	            _react2.default.createElement(_Animations.TweenOne, _extends({ key: '0',
	                component: _RetinaImage2.default,
	                srcSet: [_imgIphoneUnitCostZones2.default, _imgIphoneUnitCostZones2x2.default, _imgIphoneUnitCostZones3x2.default],
	                className: 'src-pages-features----dashboard-module---splash-image---1LZSu'
	            }, _Animations.FadeLeft))
	        )
	    );
	};
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(Hero, null),
	        _react2.default.createElement(_OptimizationDetailsSection2.default, null),
	        _react2.default.createElement(_UptimeSplash2.default, null),
	        _react2.default.createElement(_FeaturesLinksSection2.default, null)
	    );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-features-optimization-js-d7c66ff286a44fb7d41e.js